import Sidebar from "@/components/Sidebar";
import Header from "@/components/Header";
import NavArrows from "@/components/NavArrows";
import { useSidebar } from "@/contexts/SidebarContext";

export default function Layout({ title, subtitle, actions, children }) {
  const { isOpen, close } = useSidebar();
  return (
    <div className="min-h-screen bg-app bg-grain text-text-primary relative">
      <Sidebar />
      {/* Overlay para mobile/tablet cuando el sidebar está abierto */}
      {isOpen && (
        <div
          onClick={close}
          className="fixed inset-0 z-30 bg-black/40 backdrop-blur-sm lg:hidden"
          data-testid="sidebar-overlay"
        />
      )}
      <div className={`transition-all duration-300 ${isOpen ? "lg:ml-64" : "ml-0"}`}>
        <Header title={title} subtitle={subtitle} />
        {/* Anterior / Siguiente (misma ubicación en todas las secciones) y, a la derecha, las acciones de la página:
            en una fila propia que se ajusta, para que ningún botón quede fuera de la pantalla en ningún tamaño */}
        <div className="px-4 md:px-8 pt-3 relative z-20 flex flex-wrap items-center justify-between gap-2">
          <NavArrows />
          {actions && (
            <div className="flex flex-wrap items-center justify-end gap-2 max-w-full [&>div]:flex-wrap [&>div]:justify-end max-lg:[&_button]:min-h-[44px]"
              data-testid="page-actions">{actions}</div>
          )}
        </div>
        {/* Sin z-index propio: si `main` crea su propio nivel, las ventanas emergentes (z-50) quedan atrapadas
            DEBAJO del encabezado (z-30) y de Anterior/Siguiente (z-20), que tapan sus botones Guardar / X. */}
        <main className="px-4 pb-6 md:p-8 pt-3 md:pt-4 relative" data-testid="page-main">
          {children}
        </main>
      </div>
    </div>
  );
}
